import { getDefaultSendingEmail, isNilOrEmpty } from '@rentguru/commons-utils';

const DEV_STAGE_NAME_LENGTH = 5;
const PRODUCTION_STAGE = 'app';
const SENTRY_PRODUCTION_ENVIRONMENT = 'production';
const LOCAL_VERSION = 'local';
const VERSION_STAGE_SEPARATOR = ' · ';

export const getCurrentEnv = () => import.meta.env.VITE_STAGE;

export const isDevAccount = () => {
  const currentEnv = getCurrentEnv();
  return currentEnv.startsWith('dev') && currentEnv.length === DEV_STAGE_NAME_LENGTH;
};

export const PLATFORM_SENDING_EMAIL = getDefaultSendingEmail(getCurrentEnv());

export const getAppVersion = () => import.meta.env.VITE_APP_VERSION ?? LOCAL_VERSION;

export const toSentryEnvironment = (stage: string | undefined) =>
  stage === PRODUCTION_STAGE ? SENTRY_PRODUCTION_ENVIRONMENT : (stage ?? LOCAL_VERSION);

export const getSentryEnvironment = () => toSentryEnvironment(getCurrentEnv());

export const toDisplayVersion = (version: string, stage: string | undefined) =>
  isNilOrEmpty(stage) || stage === PRODUCTION_STAGE ? version : `${version}${VERSION_STAGE_SEPARATOR}${stage}`;

export const getDisplayVersion = () => toDisplayVersion(getAppVersion(), getCurrentEnv());

export const isProdEnv = (stage: string | undefined): boolean => stage === PRODUCTION_STAGE;
